import React, { useState } from "react";
import api from "../../../api";
import { notify } from "../../../utils/toast";
import "./contact.css";
export const ContactSection = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    institute: "",
    service: "contract",
    message: "",
  });
  const [loader, setLoader] = useState(false);
  const [sent, setSent] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.message) {
      notify.error("Please fill all required fields.");
      return;
    }
    try {
      setLoader(true);
      const response = await api.addEnquiry(form);
      if (response?.success) {
        setSent(true);
        setForm({
          name: "",
          email: "",
          phone: "",
          institute: "",
          service: "contract",
          message: "",
        });
      }
    } catch (e) {
      notify.error(e?.message || "Something went wrong. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  return (
    <section className="contactSec" id="contact">
      <div className="container">
        <div className="row align-items-center">
          {/* ── Left ── */}
          <div className="col-lg-5 mb-5 mb-lg-0">
            <h2 className="homeHeading" style={{ textAlign: "left" }}>
              Get In Touch
            </h2>
            <p className="para">
              Interested in our transport services? Send us your details and our
              team will get back to you within 24 hours.
            </p>

            <div className="contactInfo">
              <div className="cInfoRow">
                <div className="cInfoIcon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div>
                  <div className="cInfoLabel">Phone</div>
                  <a href="tel:+923002626482" className="cInfoValue">
                    +92 300 262 6482
                  </a>
                </div>
              </div>
              <div className="cInfoRow">
                <div className="cInfoIcon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div>
                  <div className="cInfoLabel">Phone</div>
                  <a href="tel:+923122708809" className="cInfoValue">
                    +92 312 270 8809
                  </a>
                </div>
              </div>

              <div className="cInfoRow">
                <div className="cInfoIcon">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div>
                  <div className="cInfoLabel">Email</div>
                  <a
                    href="mailto:info@shabirtransport.com"
                    className="cInfoValue"
                  >
                    info@shabirtransport.com
                  </a>
                </div>
              </div>

              <div className="cInfoRow">
                <div className="cInfoIcon">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div>
                  <div className="cInfoLabel">Location</div>
                  <div className="cInfoValue">Karachi, Pakistan</div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Right: Form ── */}
          <div className="col-lg-7">
            <div className="contactFormCard">
              {sent ? (
                <div className="contactSuccess">
                  <div className="successIcon">✅</div>
                  <h4>Message Sent!</h4>
                  <p>Thank you! We'll reach out to you within 24 hours.</p>
                  <button onClick={() => setSent(false)}>Send Another</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="cFormGroup">
                        <label>
                          Full Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          className="cFormControl"
                          placeholder="Ahsan Iqbal"
                          value={form.name}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="cFormGroup">
                        <label>
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="phone"
                          className="cFormControl"
                          placeholder="+92 300 0000000"
                          value={form.phone}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="cFormGroup">
                        <label>
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="cFormControl"
                          placeholder="you@example.com"
                          value={form.email}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="cFormGroup">
                        <label>Institute / Company</label>
                        <input
                          type="text"
                          name="institute"
                          className="cFormControl"
                          placeholder="University / Office name"
                          value={form.institute}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="cFormGroup">
                        <label>Service Interested In</label>
                        <select
                          name="service"
                          className="cFormControl"
                          value={form.service}
                          onChange={onChange}
                        >
                          <option value="contract">Contract Transport</option>
                          <option value="rental">Vehicle Rental</option>
                          <option value="student">Student Transport</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="cFormGroup">
                        <label>
                          Message <span className="text-danger">*</span>
                        </label>
                        <textarea
                          name="message"
                          className="cFormControl"
                          rows={4}
                          placeholder="Tell us about your transport needs..."
                          value={form.message}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="cSubmitBtn"
                        disabled={loader}
                      >
                        {loader ? "Sending..." : "Send Message"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
